import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaGraduationCap, FaArrowRight, FaCheckCircle } from "react-icons/fa";

// import naccLogo from "../../assets/images/nacc-logo.png";
import koolboksLogo from "../../assets/images/koolboks-logo.png";
// import memscepterLogo from "../../assets/images/memscepter-logo.png";
// import lsetfLogo from "../../assets/images/lsetf-logo.png";
import violetLogo from "../../assets/images/violet-logo.jpg";
import innovateHubLogo from "../../assets/images/innovate-hub-logo.png";
import alieKabbaLogo from "../../assets/images/Alie.png";
import diasporaLogo from "../../assets/images/diaspora.png";
import alemfLogo from "../../assets/images/alemf-logo.png";
import isfLogo from "../../assets/images/isf-logo.png";
import heroImage from "../../assets/images/young-student.webp";

const applyLink = "https://app.e1xacademy.net/pioneer-cohort";

const scholarshipsData = [
  // {
  //   id: "lsetf",
  //   title: "LSETF Scholarship",
  //   track: "Lagos State Employment Trust Fund Track",
  //   logo: lsetfLogo,
  //   description:
  //     "Backed by the Lagos State Government's mandate to end youth unemployment, this scholarship equips Lagos residents with job ready tech skills, turning the state's employability agenda into real, marketable careers for the next wave of Lagos talent.",
  //   highlights: [
  //     "Up to 100% tuition coverage",
  //     "Direct alignment with Lagos State job creation goals",
  //     "Priority access to employer and internship placements",
  //   ],
  //   color: "from-emerald-600 to-emerald-400",
  // },
  // {
  //   id: "nacc",
  //   title: "NACC Scholarship",
  //   track: "Nigerian-American Chamber of Commerce Track",
  //   logo: naccLogo,
  //   description:
  //     "Our NACC scholarship opens doors between two economies, training driven individuals to compete on a global stage while building the cross border business and tech skills that power US Nigeria trade and innovation.",
  //   highlights: [
  //     "Up to 100% tuition coverage",
  //     "Mentorship and leadership development",
  //     "Global networking opportunities across the US Nigeria corridor",
  //   ],
  //   color: "from-blue-600 to-blue-400",
  // },
  {
    id: "alemf",
    title: "Akinwale Leadership Empowerment Foundation Scholarship",
    track: "ALEMF Track",
    logo: alemfLogo,
    logoBg: "bg-slate-900",
    description:
      "ALEMF is positioning Africa as a primary architect in the global space economy through cutting-edge space science, innovative technology, and transformative leadership. This scholarship backs driven young visionaries ready to master emerging tech, solve real-world challenges, and lead the continent's next wave of technological innovation.",
    highlights: [
      "Up to 100% tuition coverage",
      "Hands-on exposure to space science, AI, and advanced data analytics",
      "Direct pathway into elite networks and mentorship from space & tech industry leaders",
    ],
    color: "from-amber-600 to-amber-400",
  },
  {
    id: "koolboks",
    title: "Koolboks Scholarship",
    track: "Koolboks Track",
    logo: koolboksLogo,
    logoBg: "bg-slate-900",
    description:
      "Koolboks is powering Africa's off grid economy with solar refrigeration, and they need the next generation of engineers, IoT developers, and clean energy technologists to keep building it. This scholarship backs driven talent ready to solve real infrastructure problems, not just study them.",
    highlights: [
      "Up to 100% tuition coverage",
      "Hands on exposure to IoT and hardware software integration",
      "Pathway into Africa's fastest growing clean tech sector",
    ],
    color: "from-green-600 to-green-400",
  },
  // {
  //   id: "memscepter",
  //   title: "Memscepter BHC Scholarship",
  //   track: "Memscepter BHC Track",
  //   logo: memscepterLogo,
  //   description:
  //     "Rooted in Memscepter BHC's belief that every individual deserves the tools to thrive, this scholarship removes financial barriers for driven beginners, extending the same compassionate, holistic commitment to human potential from healthcare into technology and opportunity.",
  //   highlights: [
  //     "Up to 100% tuition coverage",
  //     "Mentorship focused on holistic personal and career growth",
  //     "A pathway into tech for individuals regardless of background",
  //   ],
  //   color: "from-purple-600 to-purple-400",
  // },
  {
    id: "violet-abdulkadir",
    title: "Violet AbdulKadir Foundation Scholarship",
    track: "VIOLET ABDULKADIR FOUNDATION TRACK",
    logo: violetLogo,
    description:
      "Aligned with VAF's mission to empower youth and women with real access to economic opportunity, this scholarship exists for those who have the drive but not always the means, giving them structured tech training and a genuine path to independence.",
    highlights: [
      "Up to 100% tuition coverage",
      "Priority access for women and young people building new careers",
      "Support built around long term economic independence, not just certification",
    ],
    color: "from-pink-600 to-pink-400",
  },
  {
    id: "innovate-hub",
    title: "Innovate Hub Scholarship",
    track: "Innovate Hub Track",
    logo: innovateHubLogo,
    description:
      "Innovate Hub backs builders, not just learners. This scholarship is for people who want more than a certificate, they want the practical, hands-on skills to create real products, solve real problems, and turn ideas into income in the tech economy.",
    highlights: [
      "Up to 100% tuition coverage",
      "Emphasis on practical, project based learning",
      "Support geared toward turning skills into real world innovation",
    ],
    color: "from-amber-500 to-amber-300",
  },
  {
    id: "alie-kabba",
    title: "Alie Kabba Tech Scholarship",
    track: "Alie Kabba Track",
    logo: alieKabbaLogo,
    logoBg: "bg-slate-900",
    description:
      "Championed by Ambassador Alie Kabba, former Sierra Leonean Cabinet Minister and 2028 Presidential Candidate, this initiative is dedicated to driving youth empowerment across Sierra Leone through digital transformation. This scholarship breaks down financial barriers for young Sierra Leoneans, providing world-class tech training, mentorship, and practical skills to foster economic independence and position the nation's talent at the forefront of Africa's digital economy.",
    highlights: [
      "Up to 100% tuition coverage",
      "Priority access for young Sierra Leoneans looking to build high-impact tech careers",
      "Leadership mentorship and training focused on long-term economic independence",
    ],
    color: "from-emerald-600 to-emerald-400",
  },
  {
    id: "diaspora-international-platform-4-africa",
    title: "Diaspora International Platform 4 Africa Scholarship",
    track: "DIP4Africa Track",
    logo: diasporaLogo,
    description:
      "Aligned with DIP's mission to mobilise the African diaspora for continental development, this scholarship bridges global talent, capital, and networks with local ambition. Designed to accelerate sustainable growth across Africa, this track equips driven individuals with hands-on, practical tech skills and direct access to an international network of leaders, investors, and diaspora mentors.",
    highlights: [
      "Up to 100% tuition coverage",
      "Direct mentorship and networking from global African diaspora professionals",
      "Hands-on training focused on solving real-world African challenges through technology",
    ],
    color: "from-indigo-600 to-indigo-400",
  },
  {
    id: "innovation-and-scale-forum",
    title: "Innovation and Scale Forum Scholarship",
    track: "Innovation and Scale Forum Track",
    logo: isfLogo,
    description:
      "The Innovation and Scale Forum (ISF) is a premier West African platform connecting founders, investors, and policymakers to drive cross-border technology innovation and enterprise growth across Africa. This scholarship backs ambitious builders and innovators ready to master high-demand tech skills, scale digital solutions across borders, and shape the continent's economic future.",
    highlights: [
      "Up to 100% tuition coverage",
      "Hands-on exposure to venture building, digital infrastructure, and market expansion strategies",
      "Direct pathway into high-trust networks, investor briefings, and ecosystem mentorship",
    ],
    color: "from-teal-600 to-teal-400",
  },
];

const Scholarships = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 font-sans">
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white overflow-hidden py-32">
        {/* Fast Loading Background Image */}
        <div className="absolute inset-0">
          <img 
            src={heroImage} 
            alt="Students learning" 
            className="w-full h-full object-cover object-top opacity-40" 
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/80 to-transparent"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <span className="inline-block py-1 px-3 rounded-full bg-blue-500/20 text-blue-300 text-sm font-semibold tracking-wider uppercase mb-6 border border-blue-500/30">
              Transform Your Future
            </span>
            <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-8">
              Unlock Your Potential with <br className="hidden md:block" />
              <span className="text-primary">
                Premium Scholarships
              </span>
            </h1>
            <p className="mt-4 text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto font-light leading-relaxed">
              Explore our diverse scholarship tracks offering{" "}
              <span className="font-semibold text-white">up to 100% funded scholarships</span>. 
              Gain world-class tech skills and launch your career today.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Scholarships List Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="space-y-24">
            {scholarshipsData.map((scholarship, index) => (
              <motion.div
                key={scholarship.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, delay: 0.1 }}
                className={`flex flex-col lg:flex-row items-center gap-12 lg:gap-20 ${
                  index % 2 !== 0 ? "lg:flex-row-reverse" : ""
                }`}
              >
                {/* Visual / Logo Container */}
                <div className="w-full lg:w-5/12 flex justify-center">
                  <div className="relative group">
                    <div className={`absolute inset-0 bg-gradient-to-br ${scholarship.color} rounded-3xl blur-xl opacity-10 group-hover:opacity-30 transition-opacity duration-500`}></div>
                    <div className={`relative ${scholarship.logoBg || "bg-white"} p-8 rounded-3xl shadow-lg border border-gray-100 flex items-center justify-center w-64 h-64 md:w-80 md:h-80 transform group-hover:scale-105 transition-transform duration-500`}>
                      {scholarship.logo ? (
                        <img
                          src={scholarship.logo}
                          alt={`${scholarship.track} Logo`}
                          className="w-full h-full object-contain rounded-xl"
                        />
                      ) : (
                        <div className={`w-full h-full rounded-xl bg-gradient-to-br ${scholarship.color} flex items-center justify-center`}>
                          <span className="text-5xl font-extrabold text-white tracking-wider">
                            {scholarship.initials || scholarship.title?.charAt(0)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="w-full lg:w-7/12">
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`p-2 rounded-lg bg-gradient-to-r ${scholarship.color} text-white`}>
                      <FaGraduationCap size={20} />
                    </div>
                    <h3 className="text-sm font-bold tracking-widest uppercase text-gray-500">
                      {scholarship.track}
                    </h3>
                  </div>
                  <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                    {scholarship.title}
                  </h2>
                  <p className="text-xl text-gray-600 mb-8 leading-relaxed font-light">
                    {scholarship.description}
                  </p>
                  
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-2xl mb-8">
                    <h4 className="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
                      <FaCheckCircle className="text-blue-500" /> Scholarship Highlights
                    </h4>
                    <ul className="space-y-2">
                      {scholarship.highlights.map((highlight, i) => (
                        <li key={i} className="flex items-start gap-3 text-blue-800">
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0"></span>
                          <span>{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <a
                    href={applyLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold text-white rounded-full bg-gradient-to-r ${scholarship.color} hover:shadow-lg hover:opacity-90 transform hover:-translate-y-1 transition-all duration-300`}
                  >
                    Apply Now <FaArrowRight />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-slate-900 py-20 relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to start your journey?</h2>
          <p className="text-xl text-gray-300 mb-10 font-light">
            Don't miss the chance to get up to 100% scholarship on our premium tech courses.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={applyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-slate-900 px-10 py-4 rounded-full font-bold text-lg hover:bg-blue-50 hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(255,255,255,0.3)] w-full sm:w-auto"
            >
              Apply for a Scholarship Today
            </a>
            <Link 
              to="/"
              className="inline-block bg-transparent border-2 border-white/30 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-white/10 hover:border-white transition-all duration-300 w-full sm:w-auto"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Scholarships;
